import React, { Component, Fragment } from 'react';
import PropTypes from 'proptypes';
import moment from 'moment';
import config from '../../../configuration/config';
import './PaymentDetails.scss';

export default class PaymentDetails extends Component {
  state = {
    showPaymentLineItems: false,
    paymentProcessorUrl: config.paymentGateway.url,
    depositBalance: 0,
  };

  handleCurrencyChange = e => {
    const rawCurrency = e && e.target ? e.target.value : null;
    const nextCurrency = String(rawCurrency || '')
      .trim()
      .toUpperCase();

    if (this.props.onCurrencyChange && nextCurrency) {
      this.props.onCurrencyChange(nextCurrency);
    }
  };

  getCurrencyFormatter = () => {
    const currency = this.props.selectedCurrency || 'USD';
    return new Intl.NumberFormat(currency === 'CAD' ? 'en-CA' : 'en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
    });
  };

  getDisplayAmount = amountUSD => {
    const currency = this.props.selectedCurrency || 'USD';
    const rate =
      Number.isFinite(this.props.exchangeRate) && this.props.exchangeRate > 0
        ? this.props.exchangeRate
        : 1;

    const safeAmount = Number.isFinite(amountUSD) ? amountUSD : 0;
    return currency === 'CAD' ? safeAmount * rate : safeAmount;
  };

  formatAmount = amountUSD => {
    const formatter = this.getCurrencyFormatter();
    return formatter.format(this.getDisplayAmount(amountUSD));
  };

  // tripDisplayPrice = this.props.trip.productDisplayPrice;

  // componentDidMount() {
  //   this.tripDisplayPrice = this.props.trip.productDisplayPrice;
  // }

  // componentDidUpdate(prevProps) {
  //   if (prevProps.trip.productDisplayPrice !== this.props.trip.productDisplayPrice) {
  //     this.tripDisplayPrice = this.props.trip.productDisplayPrice;
  //   }
  // }

  returnLineItems = () => {
    this.tripDisplayPrice = this.props.trip.productDisplayPrice;
    let lineItems = '';
    const amountPaid = this.props.trip.payments.tripAmount - this.props.trip.payments.tripBalance;
    const items = [];
    items.push(this.props.trip);

    const discountName = this.props.trip.discountName
      ? this.props.trip.discountName
      : 'Trip Discount';
    const promotionalDiscount = this.props.trip.tripdiscountlivenow
      ? this.props.trip.tripdiscountlivenow
      : 0;

    const amountPaidLessTripDeposit = amountPaid - this.props.trip.payments.deposit;

    const tripDiscount = this.props.trip.discountApplied ? this.props.trip.discountApplied : 0;
    let tripAmount = this.props.trip.totalPrice - Math.abs(tripDiscount);

    const deposit = this.props.trip.payments
      ? this.props.trip.payments.deposit
      : this.props.trip.deposit;

    if (this.props.trip.discountApplied > 0) {
      this.tripDisplayPrice += this.props.trip.discountApplied;
    }

    if (this.props.trip.payments.deposit > amountPaid && promotionalDiscount > 0) {
      // Faux discount
      tripAmount = tripAmount - Math.abs(promotionalDiscount);
    }

    lineItems += `
      <div class="payment-row bg">
        <div class="payment-cell item-col">${
          this.props.trip.displayName ? this.props.trip.displayName : this.props.trip.destination
        }</div>
        <div class="payment-cell trip-col list-price">
          ${this.tripDisplayPrice > tripAmount ? this.formatAmount(this.tripDisplayPrice) : ''}
        </div>
        <div class="payment-cell price-col trip-price-highlighted">
          ${this.formatAmount(tripAmount)}
        </div>
        <div class="payment-cell deposit-col">
          ${
            amountPaid >= this.props.trip.payments.deposit
              ? `<span class="tag small">Secured!</span>`
              : this.formatAmount(deposit)
          }
        </div>
      </div>
    `;

    let productAddOnsDepositBalance = amountPaidLessTripDeposit;
    for (let i = 0; i < this.props.trip.currentAddOns.length; i += 1) {
      lineItems += `
        <div class="payment-row bg">
          <div class="payment-cell item-col">${this.props.trip.currentAddOns[i].name}</div>
          <div class="payment-cell trip-col"></div>
          <div class="payment-cell price-col trip-price-highlighted">
            ${this.formatAmount(this.props.trip.currentAddOns[i].unitPrice)}
          </div>
          <div class="payment-cell deposit-col">
            ${
              productAddOnsDepositBalance >= this.props.trip.currentAddOns[i].deposit
                ? `<span class="tag small">Secured!</span>`
                : this.formatAmount(this.props.trip.currentAddOns[i].deposit)
            }
          </div>
        </div>
      `;
      productAddOnsDepositBalance -= this.props.trip.currentAddOns[i].deposit;
    }

    if (this.props.trip.payments.deposit > amountPaid && promotionalDiscount > 0) {
      // Faux discount
      lineItems += `<div class="payment-row"><div class="payment-cell item-col small">${discountName}</div><div class="payment-cell trip-col small"><i>-${this.formatAmount(
        Math.abs(promotionalDiscount)
      )}</i></div><div class="payment-cell price-col"></div><div class="payment-cell deposit-col"></div></div>`;
    }

    if (this.props.trip.products && this.props.trip.products.length > 0) {
      for (let i = 0; i < this.props.trip.products.length; i += 1) {
        if (this.props.trip.products[i].productFamily === 'Trip') {
          if (this.props.trip.products[i].packageSavingsTrip > 0) {
            lineItems += `<div class="payment-row"><div class="payment-cell item-col small">Package Savings</div>
            <div class="payment-cell trip-col small"><i>-${this.formatAmount(
              Math.abs(this.props.trip.products[i].packageSavingsTrip)
            )}</i></div><div class="payment-cell price-col"></div><div class="payment-cell deposit-col"></div></div>`;
          }
        } else {
          if (this.props.trip.products[i].totalPrice !== 0) {
            lineItems += `<div class="payment-row"><div class="payment-cell item-col small">${
              this.props.trip.products[i].discountNamepublic
                ? this.props.trip.products[i].discountNamepublic
                : 'Discount'
            }</div><div class="payment-cell trip-col small"><i>${
              this.props.trip.products[i].totalPrice > 0
                ? '+' + this.formatAmount(Math.abs(this.props.trip.products[i].totalPrice))
                : '-' + this.formatAmount(Math.abs(this.props.trip.products[i].totalPrice))
            }</i></div><div class="payment-cell price-col"></div><div class="payment-cell deposit-col"></div></div>`;
          }
        }
      }
    }

    return lineItems;
  };

  togglePaymentLineItems = () => {
    this.setState({
      showPaymentLineItems: !this.state.showPaymentLineItems,
    });
  };

  returnTotalAmountDue = () => {
    const tripAmount = this.props.trip.payments.tripAmount;
    const tripBalance = this.props.trip.payments.tripBalance;
    let totalAmountDue = tripBalance;
    const promotionalDiscount = this.props.trip.tripdiscountlivenow
      ? this.props.trip.tripdiscountlivenow
      : 0;
    const amountPaid = tripAmount - tripBalance;

    if (this.props.trip.payments.deposit > amountPaid && promotionalDiscount > 0) {
      totalAmountDue = totalAmountDue - promotionalDiscount;
    }

    for (let i = 0; i < this.props.trip.currentAddOns.length; i += 1) {
      const currentAddOn = this.props.trip.currentAddOns[i];
      if (!currentAddOn.type || currentAddOn.type !== 'Product') {
        totalAmountDue += currentAddOn.unitPrice;
      }
    }
    return totalAmountDue;
  };

  render() {
    const paymentLineItems = this.returnLineItems();

    const addOnDeposits = this.props.trip.payments.addOnsDeposit;
    const depositSum = this.props.trip.payments.deposit + addOnDeposits;
    let amountPaid = this.props.trip.payments.tripAmount - this.props.trip.payments.tripBalance;
    const depositBalance = amountPaid >= depositSum ? 0 : depositSum - amountPaid;
    let tripBalance = this.returnTotalAmountDue();

    const tripDiscount = this.props.trip.discountApplied ? this.props.trip.discountApplied : 0;
    const tripAmount = this.props.trip.totalPrice + tripDiscount;

    const promotionalDiscount = this.props.trip.tripdiscountlivenow
      ? this.props.trip.tripdiscountlivenow
      : 0;

    // TODO: This should be added to this.returnTotalAmountDue()
    if (this.props.trip.payments.deposit > amountPaid && promotionalDiscount > 0) {
      tripBalance = tripBalance - this.props.trip.tripdiscountlivenow;
      this.tripDisplayPrice = this.tripDisplayPrice + this.props.trip.tripdiscountlivenow;
    }

    // if (depositBalance > 0) {
    //   let _addOnDeposits = addOnDeposits;
    //   for (let i = 0; i < this.props.trip.currentAddOns.length; i += 1) {
    //     const addOnDeposit = this.props.trip.currentAddOns[i].deposit;
    //     if (_addOnDeposits > depositBalance) {
    //       // If current deposit is greater than the deposit balance, consider it paid.
    //       _addOnDeposits -= addOnDeposit;
    //     } else {
    //       // If deposit remaining, consider it a wish-list item and add to trip balance.
    //       tripBalance += this.props.trip.currentAddOns[i].unitPrice;
    //     }
    //   }
    // }

    const penniesDue = Math.round(this.getDisplayAmount(this.returnTotalAmountDue()) * 100);

    return (
      <div className="payment-details">
        <div className="payment-grid">
          {/* Header Row */}
          <div className="payment-row payment-header">
            <div className="payment-cell item-col"></div>
            <div className="payment-cell trip-col">
              {this.tripDisplayPrice > tripAmount ? 'Trip' : ''}
            </div>
            <div className="payment-cell price-col">Your Price</div>
            <div className="payment-cell deposit-col">Deposit</div>
          </div>

          {/* Dynamic Payment Line Items */}
          <div
            className="payment-items"
            ref={el => {
              if (el) {
                el.innerHTML = paymentLineItems
                  .replace(/<tr/g, '<div class="payment-row"')
                  .replace(/<\/tr>/g, '</div>')
                  .replace(/<td/g, '<div class="payment-cell"')
                  .replace(/<\/td>/g, '</div>');
              }
            }}
          />

          {/* Summary Row */}
          <div className="payment-row payment-summary">
            <div className="payment-cell item-col padding-left">
              Deposit Balance: {`${this.formatAmount(depositBalance)}`}
            </div>
            <div className="payment-cell trip-col"></div>
            <div className="payment-cell price-col">Current Balance:</div>
            <div className="payment-cell deposit-col">
              {`${this.formatAmount(tripBalance)}`}{' '}
              {/* {this.props.isCanadianResident &&
              this.props.onCurrencyChange &&
              !this.props.currencyError ? (
              <span
                className="small muted"
                style={{ display: 'inline-flex', alignItems: 'center' }}
              >
                <select
                  value={this.props.selectedCurrency || 'USD'}
                  onChange={this.handleCurrencyChange}
                  style={{
                    border: 'none',
                    background: 'transparent',
                    padding: 0,
                    margin: 0,
                    fontSize: 'inherit',
                    color: 'inherit',
                    appearance: 'none',
                    WebkitAppearance: 'none',
                    MozAppearance: 'none',
                    cursor: 'pointer',
                  }}
                  aria-label="Currency"
                >
                  <option value="CAD">CAD</option>
                  <option value="USD">USD</option>
                </select>
                <span style={{ marginLeft: '4px', fontSize: '0.9em' }}>▾</span>
              </span>
              ) : ( */}
              <span className="small muted">{this.props.selectedCurrency || 'USD'}</span>
              {/* )} */}
            </div>
          </div>

          {/* Canceled Trip Row */}
          {this.props.trip.stageName === 'Canceled' && (
            <div className="payment-row payment-summary">
              <div className="payment-cell item-col"></div>
              <div className="payment-cell trip-col"></div>
              <div className="payment-cell price-col">Total Paid:</div>
              <div className="payment-cell deposit-col">
                {`${this.formatAmount(
                  this.props.trip.payments.tripAmount - this.props.trip.payments.tripBalance
                )}`}
              </div>
            </div>
          )}
        </div>
        <div className="data-up-info-container">
          <span
            style={{ display: 'none', cursor: 'pointer' }}
            className="small muted data-up-from-price"
            data-up-price-value={penniesDue}
            data-up-price-type="total"
          >
            or from $<span data-up-from-currency-unit-major=""></span>/mo
            <span data-up-tooltip="">
              <svg
                stroke="currentColor"
                fill="#0f9300"
                strokeWidth="0"
                viewBox="0 0 1024 1024"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"></path>
              </svg>
            </span>
            <div style={{ display: 'none' }} data-up-promo="zero-percent">
              Interest-free payments also available{' '}
            </div>
          </span>
        </div>
        {this.props.trip.payments.completedPayments &&
        this.props.trip.payments.completedPayments.length &&
        this.state.showPaymentLineItems === true ? (
          <Fragment>
            <div className="text-right">
              <button onClick={this.togglePaymentLineItems} className="btn-plain-text muted small">
                Close
              </button>
            </div>
            <div className="payment-grid completed-payments-grid">
              {/* Header Row */}
              <div className="payment-row payment-header">
                <div className="payment-cell amount-col">Amount</div>
                <div className="payment-cell date-col">Date</div>
                <div className="payment-cell status-col">Status</div>
              </div>

              {/* Completed Payments */}
              {this.props.trip.payments.completedPayments.map((payment, i) => (
                <div className="payment-row" key={`key-${i.toString()}`}>
                  <div className="payment-cell amount-col">
                    $
                    {parseFloat(
                      Math.round((payment.amount - payment.transactionFee) * 100) / 100
                    ).toFixed(2)}
                  </div>
                  <div className="payment-cell date-col">
                    {payment.status === 'Pending' && payment.paymentType === 'Check or Money Order'
                      ? 'Check or Money Order'
                      : moment(payment.date).format('M/D/YY')}
                  </div>
                  <div className="payment-cell status-col">
                    {payment.status === 'Pending' &&
                    payment.paymentType === 'Check or Money Order' ? (
                      <span className="tag">Waiting for Arrival</span>
                    ) : payment.status === 'In Process' ? (
                      <span
                        className="tag"
                        dangerouslySetInnerHTML={{
                          __html: `<a href="${this.state.paymentProcessorUrl}&key=${payment.transactionId}&pid=${payment.id}">Complete Payment</a>`,
                        }}
                      />
                    ) : (
                      `${payment.status}`
                    )}
                  </div>
                </div>
              ))}
            </div>
          </Fragment>
        ) : (
          <Fragment>
            {this.props.trip.payments.completedPayments.length > 0 ? (
              <div className="text-right">
                <button
                  onClick={this.togglePaymentLineItems}
                  className="btn-plain-text muted small"
                >
                  Show all transactions
                </button>
              </div>
            ) : (
              ''
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

PaymentDetails.propTypes = {
  trip: PropTypes.shape({
    destination: PropTypes.string,
    tripPrice: PropTypes.number,
    payments: PropTypes.shape({
      deposit: PropTypes.number,
      addOnsDeposit: PropTypes.number,
      tripAmount: PropTypes.number,
      tripBalance: PropTypes.number,
      completedPayments: PropTypes.arrayOf(
        PropTypes.shape({
          date: PropTypes.string,
          amount: PropTypes.number,
        })
      ),
    }),
    currentAddOns: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        deposit: PropTypes.number,
        unitPrice: PropTypes.number,
      })
    ),
  }).isRequired,
  selectedCurrency: PropTypes.string,
  exchangeRate: PropTypes.number,
  isCanadianResident: PropTypes.bool,
  onCurrencyChange: PropTypes.func,
  currencyError: PropTypes.bool,
};
